import useGoogleOneTap from '~/components/useGoogleOneTap';

export default useGoogleOneTap;
